import {
  ADD_NOTICE_TEMPLATE,
  ADD_NOTICE_TEMPLATE_SUCCESS,
  DELETE_NOTICE_TEMPLATE,
  DELETE_NOTICE_TEMPLATE_SUCCESS,
  EDIT_NOTICE_TEMPLATE,
  EDIT_NOTICE_TEMPLATE_SUCCESS,
  GET_NOTICE_TEMPLATE_BY_ID,
  GET_NOTICE_TEMPLATE_BY_ID_FAILURE,
  GET_NOTICE_TEMPLATE_BY_ID_SUCCESS,
  GET_NOTICE_TEMPLATES,
  GET_NOTICE_TEMPLATES_SUCCESS,
  GET_NOTICE_TEMPLATES_FAILURE,
  GET_MORE_NOTICE_TEMPLATES_SUCCESS,
  HIDE_NOTICE_TEMPLATES_LOADER,
  SHOW_NOTICE_TEMPLATES_LOADER,
  CLEAR_NOTICE_TEMPLATES_REDUCER,
} from '../constants/ActionTypes';

export const addNoticeTemplate = template => ({
  type: ADD_NOTICE_TEMPLATE,
  payload: { template },
});

export const addNoticeTemplateSuccess = template => ({
  type: ADD_NOTICE_TEMPLATE_SUCCESS,
  payload: { template },
});

export const deleteNoticeTemplate = (id, urlToRedirect = '') => ({
  type: DELETE_NOTICE_TEMPLATE,
  payload: { id, urlToRedirect },
});

export const deleteNoticeTemplateSuccess = templates => ({
  type: DELETE_NOTICE_TEMPLATE_SUCCESS,
  payload: { templates },
});

export const editNoticeTemplate = (id, template) => ({
  type: EDIT_NOTICE_TEMPLATE,
  payload: { id, template },
});

export const editNoticeTemplateSuccess = template => ({
  type: EDIT_NOTICE_TEMPLATE_SUCCESS,
  payload: { template },
});

export const getNoticeTemplateById = id => ({
  type: GET_NOTICE_TEMPLATE_BY_ID,
  payload: { id },
});

export const getNoticeTemplateByIdFailure = () => ({
  type: GET_NOTICE_TEMPLATE_BY_ID_FAILURE,
});

export const getNoticeTemplateByIdSuccess = template => ({
  type: GET_NOTICE_TEMPLATE_BY_ID_SUCCESS,
  payload: { template },
});

export const getNoticeTemplates = (loadingMore = false) => ({
  type: GET_NOTICE_TEMPLATES,
  payload: { loadingMore },
});

export const getNoticeTemplatesSuccess = (templates, pageCount) => ({
  type: GET_NOTICE_TEMPLATES_SUCCESS,
  payload: { templates, pageCount },
});

export const getNoticeTemplatesFailure = error => ({
  type: GET_NOTICE_TEMPLATES_FAILURE,
  payload: { error },
});

export const getMoreNoticeTemplatesSuccess = (templates, pageCount) => ({
  type: GET_MORE_NOTICE_TEMPLATES_SUCCESS,
  payload: { templates, pageCount },
});

export const hideNoticeLoader = () => ({
  type: HIDE_NOTICE_TEMPLATES_LOADER,
});

export const showNoticeLoader = () => ({
  type: SHOW_NOTICE_TEMPLATES_LOADER,
});

export const clearNoticeTemplatesReducer = () => ({
  type: CLEAR_NOTICE_TEMPLATES_REDUCER,
});
